import { SlideOver } from 'ui/slideOver';

import { usePanelContext } from '../../contexts/Panel';
import { PanelView } from '../../constants';
import { PanelBody } from './PanelBody';
import { PanelFooter } from './PanelFooter';
import { PanelHeader } from './PanelHeader';
import { usePanelScroll } from './hooks/usePanelScroll';
import { useMovableInkPanelRefetchEffect } from './hooks/useMovableInkPanelRefetchEffect';

export const testIds = {
  panel: 'mi-panel',
};

export const PanelContent = () => {
  const { panelView, onCancel } = usePanelContext();
  const showFooter = panelView === PanelView.Detail;

  const onScroll = usePanelScroll();
  useMovableInkPanelRefetchEffect();

  return (
    <SlideOver
      bodyContent={<PanelBody />}
      data-test={testIds.panel}
      footerContent={showFooter && <PanelFooter />}
      headerContent={<PanelHeader />}
      id="movableInkPanel"
      isOpen
      onClose={onCancel}
      onClickOutside={onCancel}
      onScroll={onScroll}
    />
  );
};
